import Swiper from "swiper";
import { Autoplay, A11y, EffectFade, Navigation } from "swiper/modules";

/**
 * Initializes all Swiper sliders on the page.
 */
export function initializeAnnouncementBar(): void {
  document.addEventListener("DOMContentLoaded", () => {
    const slideshow = document.querySelector(".js-announcement-bar-slider");

    if (slideshow instanceof HTMLElement) {
      const swiperAutoPlayOptions = slideshow.dataset.autoplayOptions
        ? JSON.parse(slideshow.dataset.autoplayOptions)
        : { autoplay: false };

      new Swiper(slideshow, {
        loop: true,
        modules: [Autoplay, A11y, EffectFade, Navigation],
        slidesPerView: 1,
        a11y: {
          enabled: true,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: (swiper) => {
            if (!swiper) return;
            const index = swiper.activeIndex;
            const currentSlide = swiper.slides[index];
            const swiperElem = swiper.el;
            if (currentSlide && swiperElem) {
              const color = currentSlide.style.color || "#ffffff";
              swiperElem.style.setProperty("--arrow-color", color);
            }
          },
        },
        ...swiperAutoPlayOptions,
      });
    }
  });
}
